<template>
  <div class="weixin-tip">
    <van-icon name="info" />
    <h4 class="weui_msg_title">请在微信中打开此应用</h4>
  </div>
</template>

<script>
export default {
  name: 'NotWechat'
}
</script>

<style lang="less" scoped>
.weixin-tip{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  .van-icon{
    font-size: 60px;
    color: #10AEFF;
  }
  h4{
    font-size: 20px;
    font-weight: 400;
    padding: 15px 0;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/routerPages/NotWechat.vue